import React from 'react';
import { SVGProps } from './SVGProps';
import classnames from 'classnames';

/**
 * Play Media Button SVG
 */
function PlayMediaSVG({ className, ...rest }: SVGProps) {
	return (
		<svg
			viewBox="0 0 44 31"
			className={classnames('roc-icon roc-icon-play', className)}
			focusable="false"
			aria-hidden="true"
			{...rest}
		>
			<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g className="roc-icon-play__fill" transform="translate(-108.000000, -752.000000)" fillRule="nonzero">
					<g transform="translate(90.000000, 291.000000)">
						<g transform="translate(0.000000, 36.000000)">
							<g transform="translate(18.000000, 425.000000)">
								<path d="M43.0805773,4.85045052 C42.5745403,2.94120573 41.0835802,1.43754427 39.1905137,0.927255208 C35.7591946,0 22,0 22,0 C22,0 8.24088594,0 4.80948632,0.927255208 C2.91641978,1.437625 1.42545969,2.94120573 0.919422706,4.85045052 C0,8.31106771 0,15.5313229 0,15.5313229 C0,15.5313229 0,22.7515781 0.919422706,26.2121953 C1.42545969,28.1214401 2.91641978,29.5624557 4.80948632,30.0727448 C8.24088594,31 22,31 22,31 C22,31 35.7591141,31 39.1905137,30.0727448 C41.0835802,29.5624557 42.5745403,28.1214401 43.0805773,26.2121953 C44,22.7515781 44,15.5313229 44,15.5313229 C44,15.5313229 44,8.31106771 43.0805773,4.85045052 Z M17.4999689,22.0867734 L17.4999689,8.9758724 L28.9999231,15.5314844 L17.4999689,22.0867734 Z"></path>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
	);
}

export default PlayMediaSVG;
